import { JPEG_FORMAT } from '@glass/common/modules/utils/fileFormats';
import { createObjectSlug } from '@glass/common/modules/utils/objectSlug';

import { OG_IMAGE_PREFIX } from '@glass/shared/modules/images/constants';

const generateOgImagePath = ({ path }) =>
  `/${OG_IMAGE_PREFIX}/${createObjectSlug({ path })}.${JPEG_FORMAT}`;

export default generateOgImagePath;
